/**
 * SIMPS Drink Lab — questions.js
 * Declarative quiz flow. UI reads this; engine never touches it.
 * Each option sets one or more UserIntent fields via `set`.
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.QUESTIONS = {
  welcome: {
    id: 'welcome',
    dash: null,
    title: 'SIMPS DRINK LAB',
    copy: "Not sure what you're drinking?\nThat's why we hired a goose.",
    sub: 'Takes about 30 seconds.\nNo chemistry degree required.',
    cta: 'ENTER THE LAB',
    next: 'drinkType'
  },
  drinkType: {
    id: 'drinkType',
    dash: "First things first. What's going in the glass?",
    title: 'What are we making?',
    options: [
      { label: 'Café', set: { drinkType: 'coffee' }, next: 'coffeeServe' },
      { label: 'Soda', set: { drinkType: 'custom_soda' }, next: 'sodaMission' },
      { label: 'Lemonade', set: { drinkType: 'lemonade' }, next: 'sharedProfile' },
      { label: 'Sparkling Water', set: { drinkType: 'sparkling' }, next: 'sharedProfile' },
      { label: 'Something Creamy', set: { drinkType: 'creamy' }, next: 'creamyMood' },
      { label: 'Iced Tea', set: { drinkType: 'iced_tea' }, next: 'sharedProfile' },
      { label: 'Mocktail', set: { drinkType: 'mocktail' }, next: 'mocktailProfile' },
      { label: 'Cocktail', set: { drinkType: 'cocktail' }, next: 'cocktailSpirit' }
    ]
  },
  coffeeServe: {
    id: 'coffeeServe', dash: 'Hot or iced?', title: 'Hot or iced?',
    options: [
      { label: 'HOT', set: { serve: 'hot' }, next: 'coffeeProfile' },
      { label: 'ICED', set: { serve: 'cold' }, next: 'coffeeProfile' },
      { label: 'SURPRISE ME', set: { serve: 'either' }, next: 'coffeeProfile' }
    ]
  },
  coffeeProfile: {
    id: 'coffeeProfile', title: 'What sounds good?',
    options: [
      { label: 'Smooth & Creamy', set: { tasteProfiles: ['creamy'], intentTags: ['smooth_creamy'] }, next: 'adventure' },
      { label: 'Sweet & Indulgent', set: { tasteProfiles: ['dessert', 'sweet'], intentTags: ['sweet_indulgent'] }, next: 'adventure' },
      { label: 'Warm & Cozy', set: { tasteProfiles: ['warm', 'cozy'], intentTags: ['warm_cozy'] }, next: 'adventure' },
      { label: 'Something Unexpected', set: { tasteProfiles: ['bold'], intentTags: ['unexpected'] }, next: 'adventure' }
    ]
  },
  sodaMission: {
    id: 'sodaMission', dash: "What's the mission?", title: "What's the mission?",
    options: [
      { label: 'FIND ME A CLASSIC', sub: 'I just want a really good soda.', set: { drinkType: 'classic_soda' }, next: 'classicSodaVibe' },
      { label: 'BUILD SOMETHING', sub: "Let's invent my own.", set: { drinkType: 'custom_soda' }, next: 'sharedProfile' }
    ]
  },
  classicSodaVibe: {
    id: 'classicSodaVibe', title: 'Pick a vibe',
    options: [
      { label: 'Creamy & Nostalgic', set: { intentTags: ['creamy_nostalgic'] }, next: 'adventure' },
      { label: 'Bright & Fruity', set: { intentTags: ['bright_fruity'] }, next: 'adventure' },
      { label: 'Spicy & Bold', set: { intentTags: ['spicy_bold'] }, next: 'adventure' },
      { label: 'Dark & Classic', set: { intentTags: ['dark_classic'] }, next: 'adventure' },
      { label: 'Sweet & Fun', set: { intentTags: ['sweet_fun'] }, next: 'adventure' },
      { label: 'Surprise Me', set: { intentTags: ['surprise_me'] }, next: 'adventure' }
    ]
  },
  sharedProfile: {
    id: 'sharedProfile', title: 'What sounds good?',
    options: [
      { label: 'Fruity & Juicy', set: { tasteProfiles: ['fruity', 'juicy'] }, next: 'adventure' },
      { label: 'Tropical', set: { tasteProfiles: ['tropical'] }, next: 'adventure' },
      { label: 'Bright & Tart', set: { tasteProfiles: ['bright', 'tart'] }, next: 'adventure' },
      { label: 'Fresh & Botanical', set: { tasteProfiles: ['fresh', 'botanical'] }, next: 'adventure' },
      { label: 'Sweet & Fun', set: { tasteProfiles: ['sweet'] }, next: 'adventure' },
      { label: 'Surprise Me', set: { intentTags: ['surprise_me'] }, next: 'adventure' }
    ]
  },
  creamyMood: {
    id: 'creamyMood', dash: "What's the mood?", title: "What's the mood?",
    options: [
      { label: 'Fruity', set: { tasteProfiles: ['fruity'] }, next: 'adventure' },
      { label: 'Vanilla & Creamy', set: { tasteProfiles: ['creamy'] }, next: 'adventure' },
      { label: 'Dessert', set: { tasteProfiles: ['dessert'] }, next: 'adventure' },
      { label: 'Tropical', set: { tasteProfiles: ['tropical'] }, next: 'adventure' },
      { label: 'Nutty', set: { tasteProfiles: ['nutty'] }, next: 'adventure' },
      { label: 'Surprise Me', set: { intentTags: ['surprise_me'] }, next: 'adventure' }
    ]
  },
  mocktailProfile: {
    id: 'mocktailProfile', title: 'What sounds good?',
    options: [
      { label: 'Tropical Escape', set: { tasteProfiles: ['tropical'] }, next: 'adventure' },
      { label: 'Fresh & Fruity', set: { tasteProfiles: ['fresh', 'fruity'] }, next: 'adventure' },
      { label: 'Bright & Refreshing', set: { tasteProfiles: ['bright', 'refreshing'] }, next: 'adventure' },
      { label: 'Floral & Botanical', set: { tasteProfiles: ['floral', 'botanical'] }, next: 'adventure' },
      { label: 'Sweet & Playful', set: { tasteProfiles: ['sweet'] }, next: 'adventure' },
      { label: 'Spicy & Bold', set: { tasteProfiles: ['spiced', 'bold'] }, next: 'adventure' },
      { label: "Dealer's Choice", set: { intentTags: ['surprise_me'] }, next: 'adventure' }
    ]
  },
  cocktailSpirit: {
    id: 'cocktailSpirit', title: 'Pick your base',
    options: [
      { label: 'Vodka', set: { spirit: 'vodka' }, next: 'cocktailProfile' },
      { label: 'Gin', set: { spirit: 'gin' }, next: 'cocktailProfile' },
      { label: 'Rum', set: { spirit: 'rum' }, next: 'cocktailProfile' },
      { label: 'Tequila', set: { spirit: 'tequila' }, next: 'cocktailProfile' },
      { label: 'Whisky', set: { spirit: 'whisky' }, next: 'cocktailProfile' },
      { label: 'Sparkling Wine', set: { spirit: 'sparkling_wine' }, next: 'cocktailProfile' },
      { label: 'You Pick', set: { spirit: 'any' }, next: 'cocktailProfile' }
    ]
  },
  cocktailProfile: {
    id: 'cocktailProfile', title: 'Flavour direction',
    options: [
      { label: 'Tropical', set: { tasteProfiles: ['tropical'] }, next: 'adventure' },
      { label: 'Fruity', set: { tasteProfiles: ['fruity'] }, next: 'adventure' },
      { label: 'Bright & Tart', set: { tasteProfiles: ['bright', 'tart'] }, next: 'adventure' },
      { label: 'Botanical', set: { tasteProfiles: ['botanical'] }, next: 'adventure' },
      { label: 'Sweet', set: { tasteProfiles: ['sweet'] }, next: 'adventure' },
      { label: 'Bold', set: { tasteProfiles: ['bold'] }, next: 'adventure' }
    ]
  },
  adventure: {
    id: 'adventure', dash: "I need to know exactly how much supervision I'm working with.", title: 'How adventurous are we feeling?',
    options: [
      { label: 'KEEP IT CLASSIC', sub: 'I know what I like.', set: { adventure: 'classic' }, next: 'result' },
      { label: "LET'S EXPERIMENT", sub: 'Show me something different.', set: { adventure: 'experiment' }, next: 'result' },
      { label: 'UNSUPERVISED GOOSE', sub: 'Dash, you have complete creative control.', set: { adventure: 'goose' }, next: 'result' }
    ]
  }
};

window.DrinkLab.QUESTION_ORDER_START = 'drinkType';